/**
 * Lazy Video Loading with IntersectionObserver
 * Loads videos only when they approach the viewport
 */

const initLazyVideoLoading = () => {
  // Check if IntersectionObserver is supported
  if (!('IntersectionObserver' in window)) {
    // Fallback for older browsers - load all videos immediately
    const lazyVideos = document.querySelectorAll('.lazy-video');
    lazyVideos.forEach(video => {
      loadVideo(video);
    });
    return;
  }

  // Create intersection observer
  const videoObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const video = entry.target;
        loadVideo(video);
        observer.unobserve(video);
      }
    });
  }, {
    // Start loading when video is 50% visible
    threshold: 0.5,
    // Start loading 100px before the video enters viewport
    rootMargin: '100px'
  });

  // Observe all lazy videos
  const lazyVideos = document.querySelectorAll('.lazy-video');
  lazyVideos.forEach(video => {
    videoObserver.observe(video);
  });
};

const loadVideo = (video) => {
  // Handle responsive video sources
  const sources = video.querySelectorAll('source[data-src]');

  if (sources.length > 0) {
    // Update all source elements with their data-src values
    sources.forEach(source => {
      const sourceSrc = source.getAttribute('data-src');
      if (sourceSrc) {
        source.src = sourceSrc;
      }
    });
  } else {
    // Fallback for videos with direct data-src attribute
    const videoSrc = video.getAttribute('data-src');
    if (videoSrc) {
      video.src = videoSrc;
    }
  }

  // Load the video (this will make the browser choose the appropriate source)
  video.load();

  // Play the video once it's loaded enough
  video.addEventListener('canplaythrough', () => {
    video.play().catch(error => {
      // Handle autoplay policy restrictions
      console.log('Video autoplay was prevented:', error);
    });
  }, { once: true });

  // Add a class to indicate the video is loaded
  video.classList.add('lazy-video-loaded');
};

export default initLazyVideoLoading;
